import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// import { TonConnectUIProvider } from '@tonconnect/ui-react'
import { TonConnectUIProvider } from '@tonconnect/ui-react';
export const TonConnectProvider = ({ children }) => (_jsx(TonConnectUIProvider, { manifestUrl: "https://manifests.delab.team/desim.txt", children: children }));
